<template>
  <div class="content-main">
    <div v-if="mydata.userFavoritesArr.length === 0">
      <p style="line-height: 300px; padding-bottom:10px;text-align: center; letter-spacing: 1px;color:#999999">
        暂无收藏
      </p>
    </div>
    <div class="book-cards" v-else>
      <greatValueCards
        v-for="(item, index) in mydata.userFavoritesArr"
        :key="index"
        :info="item.content"
        path="/layout/list/booksDetails"
        @getList="userFavoritesFn"
      ></greatValueCards>
    </div>

    <!--分页 -->
    <div
      class="gl-pagination"
      style="margin-top:14px;"
    >
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import greatValueCards from "@/components/greatValueCards/index.vue";

import { useRouter, useRoute } from "vue-router";

//引入我的收藏列表、取消收藏接口
import {
  userFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";
import { ElMessage, ElMessageBox } from "element-plus";
const router = useRouter();

const route = useRoute();

import { reactive } from "vue";
const mydata = reactive({
  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],
  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 8, // 每页条数
    total: 0, // 总的条数
  },

  userFavoritesArr: [], //收藏列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  type: "2", //写死-类型就是2
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userFavoritesFn();
}

//获取收藏列表
function userFavoritesFn() {
  userFavoritesList(mydata.userInfo.jwt, {
    type: mydata.type,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    mydata.userFavoritesArr = res.data.list.map((item) => {
      item.content.id = item.id;
      return item;
    });
    mydata.pageObj.total = res.data.count;
    // console.log(res.data.list,"第二列获取收藏列表")
  });
}

userFavoritesFn();

//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          userFavoritesFn();
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}

// //点击事件
// function fn(){
//   router.push({
//     path:"/layout/list/booksDetails"
//   })
// }
</script>

<style scoped lang="scss">
.content-main {
  // width: 916px;
  //
  // border:1px solid red;
  // margin-top: 16px;
  //  padding-bottom:40px;
  padding:0px 16px;
  overflow: visible;
  .book-cards {
    // width: 920px;
    // height:662px;
     margin-top: 16px;
    min-height: 500px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: start;
    justify-content: space-between;
    // align-content: space-between;
    overflow: auto;
    overflow: visible !important;
    // border: 1px solid red;
    // 图书组件
    .test-card {
      // width: 215px;
      // height: 320px;
      box-shadow: 0px 5px 40px 0px #0000000d;
      // border:1px solid rgba(197, 203, 206, 0.199);
      // box-shadow: 2px 2px 4px rgba(197, 203, 206, 0.5647058824);
      // margin-right: 19px;
      margin-bottom: 10px;
      img {
        display: block;
        // width: 187px;
        // height: 187px !important;
        margin: 0 auto;
      }
       :deep(.box-price){
        font-size:18px !important;
        margin-bottom:8px;
      }
      :deep(.box-content){
        margin-top:8px;
      }
    }

    // .test-card: {
    //   // margin-bottom: 0px;
    // }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>